import DataOne from "./Shipment_Table_One";
import { useEffect, useState } from "react";
import axios from "axios";
import { getShipmentsURL } from "../../../Library/URLs";
import { generateTransactionID } from "../../../Library/Utilities";
import DataTwo from "./Shipment_Table_Two";
import { Backdrop, Box, Fade, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Moment from "react-moment";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  outline: "none",
  outerWidth: "0px",
  borderRadius: "5px",
  py: 4,
  px: 2,
};

const ShipmentTable = () => {
  const [Result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalShipments, setTotalShipments] = useState(0);
  const [selectedShipment, setSelectedShipment] = useState(null);

  const handleClose = () => {
    setSelectedShipment(null);
  };

  const render = (res) => {
    switch (res) {
      case "Pending Pickup":
        return "Pending";
      case "Cancelled":
        return "Cancel";
      case "Rejected":
        return "Rejected";
      case "Delivered":
        return "Delivered";
      case "Pending Approval":
        return "Pending Approval";

      default:
        return "Success";
    }
  };

  const renderColor = (res) => {
    switch (res) {
      case "Pending Pickup":
        return "pending";
      case "Cancelled":
        return "cancel";
      case "Rejected":
        return "cancel";
      case "Delivered":
        return "success";
      case "Pending Approval":
        return "pending";

      default:
        return "success";
    }
  };

  useEffect(() => {
    const GetShipmentHistory = async () => {
      setLoading(true);
      const Data = {
        user_id: localStorage.getItem("user_id"),
        user_ses_id: localStorage.getItem("session_id"),
        company_id: localStorage.getItem("company_id"),
        transaction_id: generateTransactionID(15),
        current_page: currentPage,
      };
      await axios
        .post(getShipmentsURL, Data)
        .then((response) => {
          const res = response.data.data.shipments;
          const total_shipments = response.data.data.total_shipments;
          setLoading(false);
          setResult(res);
          setTotalShipments(total_shipments);
        })
        .catch(() => {
          setLoading(false);
        });
    };

    GetShipmentHistory();
    // eslint-disable-next-line
  }, [currentPage]);

  return (
    <div className="Shipment_Table_Wrapper">
      <h4>All Shipments</h4>
      {Result !== "" && !loading && (
        <DataOne
          data={Result}
          setSelectedShipment={setSelectedShipment}
          currentPage={currentPage}
          totalShipments={totalShipments}
          setCurrentPage={setCurrentPage}
        />
      )}
      {Result === "" && !loading && <DataTwo />}
      {loading && (
        <div className="SpinContain">
          <span className="spinner-border spinner-grow-md" />
        </div>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={selectedShipment !== null}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={selectedShipment !== null}>
          <Box sx={style} className="Rate_Modal">
            <div className="Top_section d-flex justify-content-between align-items-center">
              <h4>View Shipment</h4>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className="ShipmentInfo">
              <div className="ShipmentSection SectionDivide">
                <p className="ShipmentLabel">SENDER DETAILS</p>
                <p>{selectedShipment?.sender_name} </p>
                <p>{selectedShipment?.sender_phone_no} </p>
                <p>{selectedShipment?.sender_address_1} </p>
                <p>{selectedShipment?.sender_address_2} </p>
                <p>
                  {selectedShipment?.sender_state},{" "}
                  {selectedShipment?.sender_city}{" "}
                </p>
                <p>{selectedShipment?.sender_country} </p>
                <p>{selectedShipment?.sender_postcode} </p>
              </div>
              <div className="ShipmentSection SectionDivide">
                <p className="ShipmentLabel">RECEIVER DETAILS</p>
                <p>{selectedShipment?.receiver_name} </p>
                <p>{selectedShipment?.receiver_phone_no} </p>
                <p>{selectedShipment?.drop_off_location} </p>
                <p>
                  {selectedShipment?.receiver_state},{" "}
                  {selectedShipment?.receiver_city}{" "}
                </p>
                <p>{selectedShipment?.receiver_country} </p>
                <p>{selectedShipment?.receiver_postcode} </p>
              </div>
              <div className="ShipmentSection pe-3">
                <p className="ShipmentLabel mb-2">SHIPMENT DETAILS</p>
                <div className="ShipmentInfo">
                  <div>
                    <p className="InfoLabel">Description</p>
                    <p>{selectedShipment?.item_name} </p>
                  </div>
                  <div className="ShipRight">
                    <p className="InfoLabel">Shipment No.</p>
                    <p>{selectedShipment?.shipment_no} </p>
                  </div>
                  <div>
                    <p className="InfoLabel">Payment Method</p>
                    <p>{selectedShipment?.payment_method} </p>
                  </div>
                  <div className="ShipRight">
                    <p className="InfoLabel">Amount</p>
                    <p>{selectedShipment?.total_amount} </p>
                  </div>
                  <div className="">
                    <p className="InfoLabel">Weight</p>
                    <p>{selectedShipment?.item_weight} KG</p>
                  </div>
                  <div className="ShipRight">
                    <p className="InfoLabel">Booking Date</p>
                    <p>
                      <Moment format="MMM DD YYYY, h:mm a">
                        {selectedShipment?.date_time}
                      </Moment>
                    </p>
                  </div>
                  <div className="">
                    <p className="InfoLabel">Status</p>
                    <div className="d-flex ">
                      <div
                        className={`BtnShip ${renderColor(
                          selectedShipment?.status
                        )}`}
                      >
                        <span style={{ fontSize: 10 }}>
                          {render(selectedShipment?.status)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default ShipmentTable;
